import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import { ThemeProvider, createTheme, initializeIcons } from '@fluentui/react'
import AuthProvider from './auth/AuthProvider'
import { AppStateProvider } from './state/AppProvider'
import Layout from './pages/layout/Layout'
import Dashboard from './pages/dashboard/Dashboard'
import Feedback from './pages/feedback/Feedback'
import Conversations from './pages/conversations/Conversations'
import LLMResults from './pages/llm-results/LLMResults'
import Performance from './pages/performance/Performance'
import ProtectedRoute from './pages/ProtectedRoute'
import CallbackComponent from './auth/components/CallbackComponent'
import SilentCallbackComponent from './auth/components/SilentCallbackComponent'
import LogoutCallbackComponent from './auth/components/LogoutCallbackComponent'
import './index.css'

initializeIcons()

const cemTheme = createTheme({
  palette: {
    themePrimary: '#2B3A67',
    themeLighterAlt: '#f3f5f9',
    themeLighter: '#d0d7e7',
    themeLight: '#aab7d3',
    themeTertiary: '#6378a7',
    themeSecondary: '#324680',
    themeDarkAlt: '#27345d',
    themeDark: '#212c4f',
    themeDarker: '#18203a',
    neutralLighterAlt: '#faf9f8',
    neutralLighter: '#f3f2f1',
    neutralLight: '#edebe9',
    neutralQuaternaryAlt: '#e1dfdd',
    neutralQuaternary: '#d0d0d0',
    neutralTertiaryAlt: '#c8c6c4',
    neutralTertiary: '#a19f9d',
    neutralSecondary: '#605e5c',
    neutralPrimaryAlt: '#3b3a39',
    neutralPrimary: '#323130',
    neutralDark: '#201f1e',
    black: '#000000',
    white: '#ffffff',
  },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ThemeProvider theme={cemTheme}>
      <BrowserRouter>
        <AuthProvider>
          <AppStateProvider>
            <Routes>
              {/* OIDC callback routes (public, no auth required) */}
              <Route path="/oidc-callback/" element={<CallbackComponent />} />
              <Route path="/oidc-callback-silent/" element={<SilentCallbackComponent />} />
              <Route path="/logout-callback/" element={<LogoutCallbackComponent />} />

              {/* Protected app routes */}
              <Route path="/" element={<Layout />}>
                <Route
                  index
                  element={
                    <ProtectedRoute>
                      <Dashboard />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="feedback"
                  element={
                    <ProtectedRoute>
                      <Feedback />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="conversations"
                  element={
                    <ProtectedRoute>
                      <Conversations />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="performance"
                  element={
                    <ProtectedRoute>
                      <Performance />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="llm-results"
                  element={
                    <ProtectedRoute>
                      <LLMResults />
                    </ProtectedRoute>
                  }
                />
              </Route>
            </Routes>
          </AppStateProvider>
        </AuthProvider>
      </BrowserRouter>
    </ThemeProvider>
  </React.StrictMode>
)
